<!--
 * @FileDescription: [资质单位]ui规范
 * @Author: @liulin
 * @Date: 2023-01-04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-04 17:01:03
 -->
 <template>
  <!-- 资质单位--单位详情 -->
  <div class="qunit-detils">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Qunit' }">资质单位</el-breadcrumb-item>
      <el-breadcrumb-item>单位详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="head">
      <div class="head-column">
        <div class="head-column-item">
          <div class="oval-16"></div>
          <div class="text-title">年度自检报告</div>
          <div class="text-info">
            <span class="time">2018-09-26 16:30:58</span>
            <span class="text">提交了 年度自检报告</span>
          </div>
        </div>
        <div class="line"></div>
        <div class="head-column-item">
          <div class="oval-16 active"></div>
          <div class="text-title">资质申请登记</div>
          <div class="text-info">
            <span class="time">2018-09-26 16:30:58</span>
            <span class="text">申请了 军工资质证书</span>
          </div>
        </div>
      </div>
      <div class="head-content">
        <div class="head-content-top">
          <div class="img"></div>
          <div class="content-title">
            <span class="title">中富华商(北京)企业管理有限公司</span>
            <div class="tag">
              <span class="tag-item tag-item-01">
                <p class="tag-item-text tag-item-text-01">私营企业</p>
              </span>
              <span class="tag-item tag-item-02">
                <p class="tag-item-text tag-item-text-02">合资企业</p>
              </span>
              <span class="tag-item tag-item-03">
                <p class="tag-item-text tag-item-text-03">上市公司</p>
              </span>
              <span class="tag-item tag-item-04">
                <p class="tag-item-text tag-item-text-04">国家行政机关</p>
              </span>
              <span class="tag-item tag-item-05">
                <p class="tag-item-text tag-item-text-05">国有企业</p>
              </span>
              <span class="tag-item tag-item-06">
                <p class="tag-item-text tag-item-text-06">国有控股企业</p>
              </span>
              <span class="tag-item tag-item-07">
                <p class="tag-item-text tag-item-text-07">外资企业</p>
              </span>
            </div>
          </div>
        </div>
        <div class="head-descriptions">
          <el-descriptions>
            <el-descriptions-item label="法定代表人">钱佳艺</el-descriptions-item>
            <el-descriptions-item label="统一社会信用代码">
              6211241936092580
            </el-descriptions-item>
            <el-descriptions-item label="邮政编码">613000</el-descriptions-item>
            <el-descriptions-item label="单位性质">私营企业</el-descriptions-item>
            <el-descriptions-item label="联系人">赵汝杰</el-descriptions-item>
            <el-descriptions-item label="传真">15024961223</el-descriptions-item>
            <el-descriptions-item label="成立日期">2022-09-01</el-descriptions-item>
            <el-descriptions-item label="座机号码">0449-7473575</el-descriptions-item>
            <el-descriptions-item label="邮箱">f.yxean@nqotswrxf.cm</el-descriptions-item>
            <el-descriptions-item label="是否上市">是</el-descriptions-item>
            <el-descriptions-item label="手机号码">13829630659</el-descriptions-item>
          </el-descriptions>
          <el-descriptions>
            <el-descriptions-item label="办公地址">
              顺义胜利顺义区站前街8号永欣嘉园
            </el-descriptions-item>
            <el-descriptions-item label="注册地址">
              新顺南大街8号(BHG Mall北京华联顺义金街购物中心2层)
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="main-title">资质管理信息</div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="资质信息" name="1">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            header-cell-class-name="tableHeaderCellClassName"
            header-row-class-name="tableHeaderRowClassName"
          >
            <el-table-column prop="num" label="频次" width="80"></el-table-column>
            <el-table-column prop="name" label="资质名称" width="140"></el-table-column>
            <el-table-column prop="grade" label="申请等级" width="100"></el-table-column>
            <el-table-column
              prop="type"
              label="资料类别"
              width="100"
              sortable
            ></el-table-column>
            <el-table-column
              prop="time"
              label="登记时间"
              width="120"
              sortable
            ></el-table-column>
            <el-table-column prop="person" label="登记人" width="110"></el-table-column>
            <el-table-column prop="state" label="状态" width="120" sortable>
              <template v-slot="{ row }">
                <span class="table-cloumn">{{ row.state }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="time1"
              label="处理时间"
              width="140"
              sortable
            ></el-table-column>
            <el-table-column prop="person1" label="处理人" width="120"></el-table-column>
            <el-table-column prop="reason" label="理由"></el-table-column>
            <el-table-column prop="time2" label="剩余补全资料时间" width="150">
              <template v-slot="{ row }">
                <span class="table-cloumn" style="font-size: 16px; line-height: 20px">
                  {{ row.time2 }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="年度自检报告" name="2">年度自检报告</el-tab-pane>
        <el-tab-pane label="项目备案" name="3">项目备案</el-tab-pane>
        <el-tab-pane label="事项变动申请" name="4">事项变动申请</el-tab-pane>
        <el-tab-pane label="整改报告" name="5">整改报告</el-tab-pane>
        <el-tab-pane label="涉案人员备案" name="6">涉案人员备案</el-tab-pane>
        <el-tab-pane label="资质注销" name="7">资质注销</el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '1',
      tableData: [
        {
          num: '初次',
          name: '系统集成',
          grade: '甲级',
          type: '总体集成',
          time: '2022-08-23 05:21:19',
          person: '郑哲携',
          state: '材料不齐全',
          time1: '2022-08-23 05:21:19',
          person1: '郑哲携',
          reason: '疫情已到尾声？这5件事提醒我们，还没有到胜利的时候',
          time2: '12天 12小时 32分',
        },
        {
          num: '初次',
          name: '系统集成',
          grade: '甲级',
          type: '总体集成',
          time: '2022-08-23 05:21:19',
          person: '郑哲携',
          state: '材料不齐全',
          time1: '2022-08-23 05:21:19',
          person1: '郑哲携',
          reason: '疫情已到尾声？这5件事提醒我们，还没有到胜利的时候',
          time2: '12天 12小时 32分',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-descriptions__body {
  background-color: transparent;
}

/deep/ .el-descriptions-item__container {
  span {
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 32px;
    letter-spacing: 0px;
  }
}
/deep/ .el-descriptions-item__content {
  color: #545454;
}

/deep/ .el-descriptions-item__label {
  color: #9699a0;
}

/deep/ .el-table__row .cell {
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px;
  letter-spacing: 0px;
  color: #24262b;
}
.qunit-detils {
  padding: 20px;
}

.head {
  height: 494px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  margin-top: 23px;
  overflow: hidden;
  padding: 24px;
  box-sizing: border-box;

  .head-column {
    width: 432px;
    height: 64px;
    display: flex;

    .head-column-item {
      width: 150px;
      height: 64px;

      .oval-16 {
        width: 10px;
        height: 10px;
        background-color: #ffffff;
        border: solid 1px #0147eb;
        display: inline-block;
        border-radius: 50%;
      }

      .active {
        background-color: #2675ff;
        box-shadow: 0px 4px 8px 0px #dde0ec;
      }

      .text-title {
        width: 96px;
        height: 21px;
        font-family: Microsoft YaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #0147eb;
        margin-left: 16px;
        display: inline-block;
      }

      .text-info {
        width: 122px;
        height: 35px;
        font-family: Microsoft YaHei;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #9699a0;
        margin-left: 28px;
        margin-top: 8px;

        .time {
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #24262b;
        }

        .text {
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #545454;
        }
      }
    }
    .line {
      width: 141px;
      height: 0px;
      border: solid 1px #c4c4c4;
      margin-left: -9px;
      margin-top: 11px;
      margin-right: 6px;
    }
  }
  .head-content {
    // width: 1592px;
    // height: 342px;
    background-color: #f5f6fa;
    border-radius: 8px;
    margin-top: 30px;
    overflow: hidden;

    .head-content-top {
      display: flex;
      margin-top: 32px;
      margin-left: 40px;
    }

    .img {
      width: 80px;
      height: 80px;
      background-image: url('../../../assets/images/组11177@3x.png');
      background-size: 100%;
    }

    .content-title {
      // width: 600px;
      // height: 64px;
      margin-left: 30px;
      margin-top: 8px;

      .title {
        width: 323px;
        height: 34px;
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #24262b;
      }

      .tag {
        margin-top: 6px;

        .tag-item {
          border-radius: 4px;
          display: inline-block;
          margin-right: 8px;
          &:last-child {
            margin-right: 0;
          }
        }

        .tag-item-text {
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 19px;
          letter-spacing: 0px;
          display: inline-block;
          margin: 4px 12px;
        }

        .tag-item-01 {
          width: 72px;
          height: 24px;
          background-color: rgba(1, 71, 235, 0.2);
          .tag-item-text-01 {
            width: 48px;
            height: 16px;
            color: #0147eb;
          }
        }

        .tag-item-02 {
          width: 72px;
          height: 24px;
          background-color: rgba(98, 126, 234, 0.2);
          .tag-item-text-02 {
            width: 48px;
            height: 16px;
            color: #627eea;
          }
        }

        .tag-item-03 {
          width: 72px;
          height: 24px;
          background-color: rgba(19, 180, 64, 0.2);
          .tag-item-text-03 {
            width: 48px;
            height: 16px;
            color: #13b440;
          }
        }

        .tag-item-04 {
          width: 96px;
          height: 24px;
          background-color: rgba(240, 68, 68, 0.2);
          .tag-item-text-04 {
            width: 72px;
            height: 16px;
            color: #f04444;
          }
        }

        .tag-item-05 {
          width: 72px;
          height: 24px;
          background-color: rgba(255, 104, 3, 0.2);
          .tag-item-text-05 {
            width: 48px;
            height: 16px;
            color: #ff6803;
          }
        }

        .tag-item-06 {
          width: 96px;
          height: 24px;
          background-color: rgba(247, 147, 26, 0.2);
          .tag-item-text-06 {
            width: 72px;
            height: 16px;
            color: #f7931a;
          }
        }

        .tag-item-07 {
          width: 72px;
          height: 24px;
          background-color: rgba(138, 58, 237, 0.2);
          .tag-item-text-07 {
            width: 48px;
            height: 16px;
            color: #8a3aed;
          }
        }
      }
    }

    .head-descriptions {
      padding: 0 40px;
      margin-top: 20px;
    }
  }
}

.main {
  width: 100%;
  height: 425px;
  background-color: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  margin-top: 16px;
  padding: 24px;
  box-sizing: border-box;

  /deep/ .tableHeaderCellClassName .cell {
    font-family: Microsoft YaHei;
    font-size: 14px;
    // font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #545454;
  }

  /deep/ .tableHeaderRowClassName th {
    background-color: #ebecf0;
		padding: 5px 0;
  }

  .table-cloumn {
    font-family: Microsoft YaHei;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 17px;
    letter-spacing: 0px;
    color: #f04444;
  }

  .main-title {
    font-family: Microsoft YaHei;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 41px;
    letter-spacing: 1px;
    color: #24262b;
  }
}
</style>
